import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  // collapse styles
  header: {
    borderTop: `1px solid ${theme.onCardDivider.green_75_op_40}`,
    borderRadius: 0,
    minHeight: 'unset',
    height: 64
  },
  content: {
    padding: 0
  },
  iconButtonRoot: {
    top: 0,
    right: 0
  },
  collapse: {
    minHeight: '48px !important',
    height: 'unset !important',
    marginBottom: 0,
    padding: 0
  },
  container: {
    minHeight: 'unset',
    boxShadow: 'none'
  },
  containerOpen: {
    paddingBottom: theme.spacing(4)
  },
  singleBottom: {
    marginTop: theme.spacing(2),
    justifyContent: 'flex-end'
  }
});

export default makeStyles(styles);
